export default "__VITE_ASSET__CMVKp6un__"